/* Military Shop – Favorite proprii (msd-fav.js)
   Inimioare pe carduri/produs, număr în header, sincronizare cu serverul (cont + vizitator),
   API pentru pagina /pages/favorite (window.MSFav). */
(function () {
  'use strict';
  var CFG = window.MSF || {};
  if (!CFG.api || window.MSFav) return;

  var LS_G = 'msf_g', LS_I = 'msf_items';
  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  var gid = lsGet(LS_G);
  if (!/^[a-f0-9]{32}$/.test(gid || '')) {
    var b = new Uint8Array(16);
    (window.crypto || window.msCrypto).getRandomValues(b);
    gid = Array.prototype.map.call(b, function (x) { return ('0' + x.toString(16)).slice(-2); }).join('');
    lsSet(LS_G, gid);
  }
  var logged = !!(CFG.c && CFG.s);
  function ident() {
    var o = { g: gid };
    if (logged) { o.c = CFG.c; o.e = CFG.e; o.f = CFG.f; o.s = CFG.s; }
    return o;
  }
  function qs(o) { return Object.keys(o).map(function (k) { return encodeURIComponent(k) + '=' + encodeURIComponent(o[k] == null ? '' : o[k]); }).join('&'); }
  function api(action, data, method) {
    var o = ident(); o.action = action;
    for (var k in (data || {})) o[k] = data[k];
    if (method === 'POST') {
      return fetch(CFG.api, { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: qs(o), keepalive: true, credentials: 'omit' })
        .then(function (r) { return r.json(); });
    }
    return fetch(CFG.api + '?' + qs(o), { credentials: 'omit' }).then(function (r) { return r.json(); });
  }

  var items = [];
  try { items = JSON.parse(lsGet(LS_I) || '[]') || []; } catch (e) { items = []; }
  var notify = 1, ready = false, listeners = [];
  function ids() { var m = {}; items.forEach(function (i) { m[i.p] = 1; }); return m; }
  function save() { lsSet(LS_I, JSON.stringify(items)); }
  function has(p) { p = +p; return items.some(function (i) { return i.p === p; }); }
  function emit() { paint(); listeners.forEach(function (fn) { try { fn(items); } catch (e) {} }); }

  function add(p, v, h, pr, silent) {
    p = +p; if (!p || has(p)) return Promise.resolve();
    items.unshift({ p: p, v: v ? +v : null, h: h || '', pa: pr ? +pr : null, at: new Date().toISOString().slice(0, 19).replace('T', ' ') });
    save(); emit();
    if (!silent) toast('added');
    return api('add', { p: p, v: v || '', h: h || '', pr: pr || '' }, 'POST').catch(function () {});
  }
  function remove(p) {
    p = +p; items = items.filter(function (i) { return i.p !== p; });
    save(); emit();
    return api('remove', { p: p }, 'POST').catch(function () {});
  }
  function sync() {
    return api('list').then(function (r) {
      if (!r || !r.items) return;
      items = r.items; notify = r.notify; ready = true; save(); emit();
    }).catch(function () { ready = true; emit(); });
  }

  function paint() {
    var m = ids();
    var btns = document.querySelectorAll('.msf-btn[data-msf-p]');
    for (var i = 0; i < btns.length; i++) {
      var on = !!m[btns[i].getAttribute('data-msf-p')];
      if (btns[i].getAttribute('aria-pressed') !== String(on)) {
        btns[i].setAttribute('aria-pressed', String(on));
        var t = on ? 'Scoate din favorite' : 'Adaugă la favorite';
        btns[i].setAttribute('aria-label', t); btns[i].title = t;
      }
    }
    var n = items.length;
    var cs = document.querySelectorAll('[data-msf-count]');
    for (var j = 0; j < cs.length; j++) {
      if (cs[j].textContent !== String(n)) cs[j].textContent = n;
      cs[j].setAttribute('data-total', n); cs[j].hidden = n === 0;
    }
    var links = document.querySelectorAll('.wishlist-page-widget');
    for (var k = 0; k < links.length; k++) { if (links[k].getAttribute('href') !== CFG.page) links[k].setAttribute('href', CFG.page); links[k].setAttribute('aria-label', 'Favorite (' + n + ')'); }
  }

  function currentVariant(btn) {
    var scope = btn.closest('form') || btn.closest('product-form-component, .product-information, [data-product-id]') || document;
    var inp = scope.querySelector && scope.querySelector('form[action*="/cart/add"] [name="id"], [name="id"]');
    return (inp && inp.value) || btn.getAttribute('data-msf-v');
  }

  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest && ev.target.closest('.msf-btn[data-msf-p]');
    if (!btn) return;
    ev.preventDefault(); ev.stopPropagation();
    var p = btn.getAttribute('data-msf-p');
    btn.classList.remove('msf-pop'); void btn.offsetWidth; btn.classList.add('msf-pop');
    if (has(p)) { remove(p); toast('removed'); }
    else add(p, currentVariant(btn), btn.getAttribute('data-msf-h'), btn.getAttribute('data-msf-pr'));
  }, true);

  var tEl, tTimer;
  function toast(kind) {
    if (!tEl) {
      tEl = document.createElement('div'); tEl.className = 'msf-toast'; tEl.setAttribute('role', 'status'); tEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(tEl);
    }
    var hint = !logged && kind === 'added' && !lsGet('msf_hint');
    if (hint) lsSet('msf_hint', '1');
    tEl.innerHTML = kind === 'added'
      ? '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M12 20.6s-7.4-4.5-9.5-9.1C1 8.1 3 4.3 6.6 3.9c2-.2 3.9.8 5.4 2.6 1.5-1.8 3.4-2.8 5.4-2.6 3.6.4 5.6 4.2 4.1 7.6-2.1 4.6-9.5 9.1-9.5 9.1z"/></svg>'
        + '<span>Adăugat la favorite' + (hint ? '<small>Intră în cont ca să le ai pe orice dispozitiv și să afli când se ieftinesc.</small>' : '') + '</span>'
        + '<a href="' + CFG.page + '">Vezi lista</a>'
      : '<span>Scos din favorite</span>';
    tEl.classList.add('is-on');
    clearTimeout(tTimer); tTimer = setTimeout(function () { tEl.classList.remove('is-on'); }, hint ? 6000 : 3200);
  }

  function pdpCount() {
    var b = document.querySelector('.msf-btn--pdp[data-msf-p]');
    if (!b) return;
    fetch(CFG.api + '?action=count&p=' + b.getAttribute('data-msf-p')).then(function (r) { return r.json(); }).then(function (r) {
      var n = (r && r.count) || 0, el = b.querySelector('.msf-num');
      if (el && n >= 3) { el.textContent = n > 999 ? '999+' : n; el.hidden = false; b.title = 'Salvat la favorite de ' + n + ' clienți'; }
    }).catch(function () {});
  }

  /* carduri adăugate dinamic (filtre, încărcare infinită, căutare): doar când apar inimioare noi */
  var moT;
  function watch() {
    if (!window.MutationObserver) return;
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        if (list[i].addedNodes.length) { clearTimeout(moT); moT = setTimeout(paint, 80); return; }
      }
    }).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
  }

  window.MSFav = {
    cfg: CFG, logged: logged, get items() { return items.slice(); }, get notify() { return notify; }, get ready() { return ready; },
    has: has, add: add, remove: remove, sync: sync, api: api, toast: toast,
    onChange: function (fn) { listeners.push(fn); },
    setNotify: function (on) { notify = on ? 1 : 0; return api('notify', { on: on ? 1 : 0 }, 'POST'); },
    share: function () { return api('share').then(function (r) { return r.token; }); },
    cartEvent: function (p) { return api('cart', { p: p }, 'POST').catch(function () {}); }
  };

  function boot() {
    paint(); watch(); pdpCount();
    if ('requestIdleCallback' in window) requestIdleCallback(sync, { timeout: 3000 }); else setTimeout(sync, 1500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
